export const COLOR = {
  DEFAULT: `var(--cn-typo-default-color)`,
  PRIMARY: `var(--cn-typo-primary-color)`,
  WARNING: 'var(--cn-color-warning)',
}